export default __webpack_public_path__ + "content/media/imgfondo.290c7d3e.png";